import type {
  PreregistrationCity,
  PreregistrationReceipt,
  PreregistrationSubmission,
  PreregistrationRegistrationOptions,
  PublicPreregistration
} from '~/shared-kernel/domain/preregistration'
export interface PublicPreregistrationRepository {
  get(slug: string, background?: boolean): Promise<PublicPreregistration>
  cities(search: string): Promise<PreregistrationCity[]>
  submit(
    slug: string,
    input: PreregistrationSubmission
  ): Promise<PreregistrationReceipt>
  registrationOptions(): Promise<PreregistrationRegistrationOptions>
}
export function createPreregistrationUseCases(
  repository: PublicPreregistrationRepository
) {
  return {
    get: (slug: string) => repository.get(slug),
    refreshStatus: (slug: string) => repository.get(slug, true),
    cities: (search: string) => repository.cities(search),
    submit: (slug: string, input: PreregistrationSubmission) =>
      repository.submit(slug, input),
    registrationOptions: () => repository.registrationOptions()
  }
}
